import React from 'react'; //, { Component }
import InputComponent from './InputComponent';
import { FaDownload } from 'react-icons/fa';

export default class ItemView extends React.Component {
    constructor(props) {
        super(props);

        console.log(this.props);
        this.state = {
            isEditable: (this.props.enabled ? true : false)
        };
        this.onEdit = this.onEdit.bind(this);
    }

    onEdit() {
        this.setState({ isEditable: !this.state.isEditable });
    }

    render() {
        const { title, onUpdate, data, onPreview, onDelete, onSave,
            disablePreview, disableEdit, disableDelete, disableSave,
        } = this.props;
        const { isEditable } = this.state;
        let tmp = [], cols = [[], []];
        const { onEdit } = this;

        const export_rows = [["項目", "值"]];
        for (let i in data) {
            let obj = data[i];
            // obj.data.label = i+" "+obj.data.label;
            // if( true == obj.hide ){
            tmp.push(<InputComponent
                id={i}
                type={obj.type}
                key={i}
                data={obj.data}
                isEditable={(obj.hide || false == obj.data.editable) ? false : isEditable}
                onUpdate={onUpdate} />);
            cols[obj.col || 0].push(<div key={i}>{tmp}</div>);
            tmp = [];
            export_rows.push([obj.data.label, obj.data.value]);

        }
        // if (tmp.length > 0) {
        //     lists.push(<div key={data.length - 1} className="row">{tmp}</div>);
        // }

        let csvContent = "data:text/csv;charset=utf-8," + export_rows.map(e => e.join(",").replace(/\n/ig, '')).join("\n");
        let download_uri = encodeURI(csvContent);
        let filename = this.props.fileName ? this.props.fileName + ".csv" : "ezc_export_" + new Date().toISOString().slice(0, 10) + ".csv";

        let editBtn = null;
        if (!disableEdit) {
            if (false == isEditable) {
                editBtn = (<button className="btn btn-success margin-right-5" onClick={onEdit}>修改</button>);
            }
        }

        let saveBtn = null;
        if (!disableSave) {
            if (isEditable) {
                saveBtn = (<button className="btn btn-success margin-right-5" onClick={onSave}>儲存</button>);
            } else {
                saveBtn = (<button disabled className="btn btn-success margin-right-5" onClick={onSave}>儲存</button>);
            }
        }
        try {
            return (
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-12 col-md-8">
                            <h1>{title}&nbsp;<a className="font-20" href={download_uri} download={filename}><FaDownload /></a></h1>
                        </div>
                        <div className="col-12 col-md-4 text-right">
                            {editBtn}
                            {(!disablePreview) && (<button className="btn btn-success margin-right-5" onClick={onPreview}>預覽</button>)}
                            {saveBtn}
                            {(!disableDelete) && (<button className="btn btn-success" onClick={onDelete}>刪除</button>)}
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-12 col-sm">{cols[0]}</div>
                        <div className="col-12 col-sm">{cols[1]}</div>
                    </div>
                </div>
            );
        } catch (e) {
            console.log(e);
            return (<div>error</div>);
        }
    }
}